import React from "react";
import { PcpConfirmDialog } from "./PcpConfirmDialog";


interface LeaveLessonDialogProps {
    open: boolean;
    title: string;
    content: string;
    onClose: () => void;
    onConfirmLeave: () => void;
}

export const LeaveLessonDialog = (props: LeaveLessonDialogProps): JSX.Element => (
    <PcpConfirmDialog
        title={props.title}
        onClose={props.onClose}
        open={props.open}
        content={props.content}
        onConfirm={props.onConfirmLeave}
        cancelText={'Nein'}
        confirmText={'Ja, verlassen'}
    />
);
